import { useState } from "react";
import { StepOneParentValidation } from "../RegisterValidation";
import CustomInput from "../../ui/custom-inputs/CustomInput";

function ParentStepOne({ setStep, formData, handleChange }) {
  const [formErrors, setFormErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = StepOneParentValidation(formData)

    if (Object.keys(err).length === 0) {
      setFormErrors(err);
      setStep(2);
    } else {
      setFormErrors(err);
    }
  };
  
  return (
    <>
      <form
        className='bg-[#bbb9b4] border p-3 shadow-md rounded-md text-sm w-[20rem] sm:w-[27rem]'
        onSubmit={handleSubmit}
      >
        <div className=' flex justify-between'>
          <h4 className=' text-white text-sm'> خطوة 1 من اصل 2</h4>
          <h4 className=' text-white'> بيانات ولي الامر</h4>
        </div>
        <div className='w-full bg-gray-200 rounded-full h-1 relative mt-3'>
          <div className='bg-primary h-1 rounded-full  absolute right-0 w-1/2 '></div>
        </div>
        <br />
        <label className=' flex flex-col items-end text-white'>
          اسم ولي الامر
          <CustomInput
            required
            type='text'
            dir='rtl'
            placeholder='ادخل الاسم الثلاثي'
            name='parentName'
            value={formData.parentName || ""}
            onChange={handleChange}
          />
          {formErrors && (
            <>
              <p className=' text-xs text-red-500'>{formErrors.parentName}</p>
            </>
          )}
        </label>
        <div className=' flex mt-3 mb-3 md:flex-row flex-col'>
          <label className=' flex flex-col text-end w-full text-white'>
            رقم الجوال
            <CustomInput
              required
              type='tel'
              dir='rtl'
              placeholder='ادخل رقم جوال فعال'
              name='phone'
              value={formData.phone || ""}
              onChange={handleChange}
            />{" "}
            {formErrors && (
              <>
                <p className=' text-xs text-red-500 w-48'>{formErrors.phone}</p>
              </>
            )}
          </label>
          <label className=' flex flex-col text-end w-full ml-4 text-white'>
            البريد الالكتروني
            <CustomInput
              required
              type='email'
              placeholder='ادخل بريد الكتروني فعال'
              dir='rtl'
              name='email'
              value={formData.email || ""}
              onChange={handleChange}
            />
            {formErrors && (
              <>
                <p className=' text-xs text-red-500'>{formErrors.email}</p>
              </>
            )}
          </label>
        </div>
        <label className=' flex flex-col items-end text-white'>
          كلمة المرور
          <CustomInput
            required
            type='password'
            dir='rtl'
            placeholder='ادخل كلمة سر اكثر من 8 خانات'
            name='password'
            value={formData.password || ""}
            onChange={handleChange}
          />{" "}
          {formErrors && (
            <>
              <p className=' text-xs text-red-500 w-96' dir='rtl'>
                {formErrors.password}
              </p>
            </>
          )}
        </label>
        <br />
        <input
          value='حفظ البيانات واستكمال بيانات الطفل
              '
          type='submit'
          className=' cursor-pointer text-center border-2 bg-primary w-full text-white rounded-xl h-10'
        />
      </form>
    </>
  );
}

export default ParentStepOne;
